<template>
  <RouterLink
      :to="route"
      :class="`${textColorClass} text-${textSize} hover:${hoverClass} font-${fontWeight} ${addClassOption}`"
      :active-class="activeClass"
  >
    {{ text }}
  </RouterLink>
</template>

<script setup lang="ts">
import {RouterLink} from "vue-router";

interface Props {
  route?: string
  text?: string
  textSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  textColorClass?: string
  fontWeight?: 'light' | 'medium' | 'bold'
  activeClass?: string
  hoverClass?: string
  addClassOption?: string
}

withDefaults(defineProps<Props>(), {
  route: '/',
  size: 'md',
  text: 'Button',
  textSize: 'sm',
  textColorClass: 'text-gray-600',
  fontWeight: 'medium',
  activeClass: 'text-primary-600',
  hoverClass: 'text-primary-600',
  addClassOption: '',
})
</script>